const SubAbasProdutosDaf = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/produtosdaf/produtos/${id}/dadosgerais`,
  },
  // {
  //   label: 'Vínculos',
  //   rota: `/daf/produtosdaf/produtos/ficha/${id}/vinculos`,
  // },
];

export default SubAbasProdutosDaf;
